<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" title="详情" width="1200px" top='3vh' :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close='true'>
    <div class="detail-content" v-loading='dialogLoading'>
      <div class="dialog-header">
        <p class="header-title">{{ this.dataForm.name }}</p>
        <div class="status">
          <el-button class="btn" type="primary" size="small" v-if="this.dataForm.onOffStatus === true" >正常</el-button>
          <el-button class="btn" type="danger" size="small"  v-if="this.dataForm.onOffStatus === false">异常</el-button>
          <el-button class="btn" size="small" @click="handlePageChange">开关控制</el-button>
        </div>
      </div>
      <div class="swith-content" v-for="(item, index) in switchList" :key="item.id">
        <p class="swith-title">{{ item.name }}</p>
        <div class="realtime-data">
          <p class="title">实时数据</p>
          <el-row :gutter="12">
            <el-col :span="8">
              <div class="data-item">
                <p>A相电压 {{item.Ua}}</p>
                <p>B相电压 {{item.Ub}}</p>
                <p>C相电压 {{item.Uc}}</p>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="data-item">
                <p>A相电流 {{item.Ia}}</p>
                <p>B相电流 {{item.Ib}}</p>
                <p>C相电流 {{item.Ic}}</p>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="data-item">
                <p>总有功功率 {{item.P}}</p>
                <p>总无功功率 {{item.Q}}</p>
                <p>总视在功率 {{item.S}}</p>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="chart-content">
          <p class="title">趋势曲线</p>
          <el-radio-group v-model="type" size="small" @change="handleChartChange(type, index, item.id)">
            <el-radio-button v-for="item in typeList" :key="item.value" :label="item.value" >{{ item.name }}</el-radio-button>
          </el-radio-group>
          <charts-component :data-cid="'chart' + index" :ref="'chart' + index" class="dialog-chart" :className="'dialog-chart' + item.id"></charts-component>
        </div>
        <div class="log-content">
          <p class="title">操作日志</p>
          <el-table ref="table" class="simple-table" :data="item.logList" max-height="300px" highlight-current-row fit border >
            <el-table-column prop="measureName" label="开关" align="left" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="command" label="状态" align="left" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="userNickname" label="操作人" align="left" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="time" label="变更时间" align="left" min-width="100" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
        <div class="warn-content">
          <p class="title">告警信息</p>
          <el-table ref="table" class="simple-table" :data="item.warnList" max-height="300px" highlight-current-row fit border >
            <el-table-column prop="rentalAreaName" label="房间" align="left" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="measureName" label="开关" align="left" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="content" label="内容" align="left" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="eventTime" label="时间" align="left" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="handlingUserNickname" label="状态" align="left" min-width="100" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import chartsComponent from './chartsComponent.vue'
export default {
  name: 'DetailDialog',
  components: {
    chartsComponent
  },
  data () {
    return {
      btnSize: 'small',
      dialogLoading: false,
      visible: false,
      dataForm: {},
      title: '',
      switchList: [],
      type: 'U',
      typeList: [
        { name: '电压', value: 'U' },
        { name: '电流', value: 'I' },
        { name: '功率', value: 'P' }
      ],
      typeNameList: {
        201: 'A相电压',
        202: 'B相电压',
        203: 'C相电压',
        207: 'A相电流',
        208: 'B相电流',
        209: 'C相电流',
        211: '总有功功率',
        215: '总无功功率',
        223: '总视在功率'
      },
      options: {
        legend: {
          x: 'center',
          data: []
        },
        // grid: {
        //   top: '3%',
        //   left: '3%',
        //   right: '0',
        //   bottom: '6%'
        // },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'time'
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [],
          type: 'line'
        }],
        dataZoom: [
          { show: true, realtime: true, start: 0, end: 100 },
          { type: 'inside', realtime: true, start: 0, end: 100 }
        ]
      }
    }
  },
  computed: {
  },
  methods: {
    handlePageChange () {
      this.visible = false
      this.$router.push({path: '/property/switchControl/index'})
    },
    init (row, isSwitch) {
      this.dialogLoading = true
      this.dataForm = Object.assign({}, row)
      this.switchList = isSwitch === true ? [this.dataForm] : this.dataForm.switchList
      this.switchList = this.switchList.map((item) => {
        return {
          ...item,
          chartList: [],
          logList: [],
          warnList: []
        }
      })
      // console.log(isSwitch, this.dataForm, this.switchList)
      // let idList = this.switchList.map((item) => {
      //   return item.id
      // })
      // this.$api.measure.getMeasuresExpressions(idList).then((res) => {
      //   if (res.success) {
      //     console.log(res)
      //   }
      // })
      this.visible = true
      this.$nextTick(() => {
        this.handleChartListInit()
        this.handleLogList()
        this.handleWarnList()
      })
      setTimeout(() => {
        this.dialogLoading = false
      }, 800)
    },
    handleChartListInit () {
      // 拿采集数据
      let chartApi = this.switchList.map((item) => {
        let measures = [
          { measureId: item.id, pointNumber: 0, pointCode: 201 },
          { measureId: item.id, pointNumber: 0, pointCode: 202 },
          { measureId: item.id, pointNumber: 0, pointCode: 203 }
        ]
        let startTime = this.$moment(new Date()).startOf('d').format('yyyy/MM/DD HH:mm:ss')
        let endTime = this.$moment(new Date()).add(1, 'd').startOf('d').format('yyyy/MM/DD HH:mm:ss')
        return this.$api.measuring.getMeasuringValue2(measures, startTime, endTime, 0, 0)
      })
      Promise.all(chartApi).then((res) => {
        if (res[0].success) {
          res.forEach((item, index) => {
            this.switchList[index].chartList = item.data
            console.log(item.data)
          })
          for (let i = 0; i < this.switchList.length; i++) {
            let codeList = [201, 202, 203]
            let legendData = codeList.map((item) => {
              return this.typeNameList[item]
            })
            let series = this.switchList[i].chartList.map((item, index) => {
              console.log(item.data.data)
              return {
                name: this.typeNameList[item.pointCode],
                data: item.data.data.map((item) => {
                  return {
                    value: [item.time, item.value]
                  }
                }),
                type: 'line'
              }
            })
            console.log(series)
            let option = Object.assign({}, this.options)
            option.legend.data = legendData
            option.series = series
            console.log(option)
            this.$nextTick(() => {
              this.$refs['chart' + i][0].init(option)
            })
            this.$nextTick(() => {
              console.log('ref', this.$refs, this.$refs['chart' + i], this.$refs['chart' + i][0])
              this.$refs['chart' + i][0].init(option)
            })
            // console.log('series', series)
          }
        }
      })
    },
    handleChartChange (type, index, id) {
      let codeList = []
      switch (type) {
        case 'U':
          codeList = [201, 202, 203]
          break
        case 'I':
          codeList = [207, 208, 209]
          break
        case 'P':
          codeList = [211, 215, 223]
          break
      }
      let measures = codeList.map((item) => {
        return {
          measureId: id,
          pointNumber: 0,
          pointCode: item
        }
      })
      let legendData = codeList.map((item) => {
        return this.typeNameList[item]
      })
      let startTime = this.$moment(new Date()).startOf('d').format('yyyy/MM/DD HH:mm:ss')
      let endTime = this.$moment(new Date()).add(1, 'd').startOf('d').format('yyyy/MM/DD HH:mm:ss')
      this.$api.measuring.getMeasuringValue2(measures, startTime, endTime, 0, 0).then((res) => {
        if (res.success) {
          this.switchList[index].chartList = res.data
          let series = this.switchList[index].chartList.map((item, index) => {
            // console.log(item.data.data)
            return {
              name: this.typeNameList[item.pointCode],
              data: item.data.data.map((item) => {
                return {
                  value: [item.time, item.value]
                }
              }),
              type: 'line'
            }
          })
          let option = Object.assign({}, this.options)
          option.legend.data = legendData
          option.series = series
          this.$nextTick(() => {
            console.log('ref', this.$refs, this.$refs['chart' + index])
            this.$refs['chart' + index][0].init(option)
          })
        }
      })
    },
    handleLogList () {
      let logApi = this.switchList.map((item) => {
        return this.$api.command.getRecentHistoryOfMeasureCommandExecuting(item.id, null)
      })
      Promise.all(logApi).then((res) => {
        if (res[0].success) {
          res.forEach((item, index) => {
            this.switchList[index].logList = item.data
          })
        }
      })
    },
    handleWarnList () {
      // let startTime = this.$moment(new Date()).subtract(6, 'M').startOf('d').format('yyyy/MM/DD HH:mm:ss')
      let startTime = this.$moment(new Date()).startOf('d').format('yyyy/MM/DD HH:mm:ss')
      let endTime = this.$moment(new Date()).add(1, 'd').startOf('d').format('yyyy/MM/DD HH:mm:ss')
      let warnList = this.switchList.map((item) => {
        return this.$api.event.getEventRecordForProperty(0, [this.dataForm.id], [], [], null, null, null, startTime, endTime, 1, 100)
      })
      Promise.all(warnList).then((res) => {
        if (res[0].success) {
          res.forEach((item, index) => {
            this.switchList[index].warnList = item.data
            console.log('warnList', this.switchList[index].warnList)
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-content {
  text-align: left;
  height: 720px;
  overflow: auto;
}

p {
  margin: 0;
}

.dialog-header {
  display: flex;
  .header-title {
    font-size: 28px;
    font-weight: bold;
  }
  .status {
    margin-left: 48px;
  }
}
.swith-content {
  margin: 24px 0;
  .swith-title {
    margin: 16px 0;
    font-size: 24px;
    font-weight: bold;
  }
}
.realtime-data {
  margin-bottom: 16px;
  padding: 0 0 16px 0;
  border-bottom: 1px solid #ddd;
  overflow: hidden;
  .title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 12px;
  }
  .data-item {
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
    padding: 0 24px;
    background-color: #eee;
    p {
      margin: 8px 0;
      font-size: 14px;
    }
  }
}

.chart-content {
  margin-bottom: 16px;
  padding: 0 0 16px 0;
  border-bottom: 1px solid #ddd;
  .title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 12px;
  }
}

.log-content {
  margin-bottom: 16px;
  padding: 0 0 16px 0;
  border-bottom: 1px solid #ddd;
  .title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 12px;
  }
}

.warn-content {
  margin-bottom: 16px;
  padding: 0 0 16px 0;
  border-bottom: 1px solid #ddd;
  .title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 12px;
  }
}

.dialog-chart {
  width: 100%;
  height: 360px;
}
</style>
